class ProductInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.quantityChange = event => this.handleQuantityChange(event);
    // Update the qty input when the quantity is changed
    window.addEventListener('quantity-change', this.quantityChange);

    // Expose the info column height so the sticky top offset in
    // main-product.liquid can make the column stick at its bottom
    // once the user has scrolled through it
    this.infoColumn = this.closest('[data-product-info]');
    if (this.infoColumn) {
      this.infoResizeObserver = new ResizeObserver(([entry]) => {
        const blockSize = entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height;
        this.infoColumn.style.setProperty('--product-info-height', `${blockSize}px`);
      });
      this.infoResizeObserver.observe(this.infoColumn);
    }
  }

  handleQuantityChange(event) {
    const { quantity, id } = event.detail;
    this.productForm = this.querySelector('product-form-component form');
    if (!this.productForm) return;

    this.productForm.querySelector('input[name="quantity"]').value = quantity;
  }

  disconnectedCallback() {
    window.removeEventListener('quantity-change', this.quantityChange);
    this.infoResizeObserver?.disconnect();
  }
}
if (!customElements.get('product-info')) {
  customElements.define('product-info', ProductInfo);
}

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.options = {
      screenSize: 'both',
    };

    if (this?.dataset?.options) {
      const dataOptions = JSON.parse(this.dataset.options);
      this.options = {
        ...this.options,
        ...dataOptions,
      };
    }

    this.productForm = document.querySelector('[data-product-form]');
    this.quickAddWrapper = this;
    this.fixedClass = 'is-fixed';
    // Body hook, so third-party overlays (e.g. the Klaviyo popup) can be repositioned or re-stacked while the bar is visible
    this.bodyVisibleClass = 'sticky-add-to-cart-visible';
    this.minBreakpoint = this.options.screenSize === 'mobile' ? 0 : this.options.screenSize === 'desktop' ? 1024 : 0;
    this.maxBreakpoint = this.options.screenSize === 'mobile' ? 767 : this.options.screenSize === 'desktop' ? 9999 : 9999;

    // On scroll, observe the product form on mobile and make it fixed when necessary
    this.debouncedOnScroll = () => {
      if (window.windowWidth <= this.minBreakpoint || window.windowWidth >= this.maxBreakpoint) {
        this.quickAddWrapper.classList.remove(this.fixedClass);
        document.body.classList.remove(this.bodyVisibleClass);
        document.body.style.paddingBottom = 0;
        return;
      }
      // check for window height for accessibility. We don't fix the element for small screens
      if (window.windowHeight > 480) this.productInfoObserver();
    };

    window.addEventListener('window:scroll', this.debouncedOnScroll);
    window.addEventListener('window:resize', this.debouncedOnScroll);
  }

  disconnectedCallback() {
    window.removeEventListener('window:scroll', this.debouncedOnScroll);
    window.removeEventListener('window:resize', this.debouncedOnScroll);
  }

  /**
   * productInfoObserver
   * @description Observe the product form and add/remove the sticky class when necessary.
   */
  productInfoObserver() {
    // Register IntersectionObserver
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Check if the top of the element is at or above the top of the viewport
        const isTopVisible = entry.boundingClientRect.top <= 0;
        if (isTopVisible) {
          if (this.quickAddWrapper.classList.contains(this.fixedClass)) return;

          this.quickAddWrapper.classList.add('hiding');
          setTimeout(() => {
            this.quickAddWrapper.classList.add(this.fixedClass);
            this.quickAddWrapper.classList.remove('hiding');
          }, 500);
          // set the height of the element to the same height as the wrapper so there's no jump when the sticky (fixed) class is applied. Also wait a bit because the dynamic checkout might be loaded later
          setTimeout(() => {
            document.body.style.paddingBottom = `${this.quickAddWrapper.children[0].clientHeight}px`;
            document.body.classList.add(this.bodyVisibleClass);
          }, 500);
        }
        else {
          this.quickAddWrapper.classList.remove(this.fixedClass);
          document.body.classList.remove(this.bodyVisibleClass);
          document.body.style.paddingBottom = 0;
        }
      });
    });

    // Declares what to observe, and observes its properties.
    observer.observe(this.productForm);
  }
}
if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
